import React, { useMemo } from 'react';
import styled from 'styled-components';
import Typography from './atoms/Typography';

export type AlertType = 'Default' | 'Info' | 'Warning' | 'Danger' | 'Success';

const getBackgroundColor = (type: AlertType): string => {
  switch (type) {
    case 'Success':
      return 'var(--color-status-success-bg)';
    case 'Danger':
      return 'var(--color-status-danger-bg)';
    case 'Warning':
      return 'var(--color-badge-warning-bg)';
    case 'Default':
      return 'var(--color-bg-primary)';
    case 'Info':
      return 'var(--color-badge-info-bg)';
  }
};

const getBorderColor = (type: AlertType): string => {
  switch (type) {
    case 'Success':
      return 'var(--color-badge-success-border)';
    case 'Danger':
      return 'var(--color-badge-danger-border)';
    case 'Warning':
      return 'var(--color-badge-warning-border)';
    case 'Default':
      return 'var(--color-border-tertiary)';
    case 'Info':
      return 'var(--color-badge-info-border)';
  }
};

const AlertDiv = styled.div<{ type: AlertType }>`
  background-color: ${(props) => getBackgroundColor(props.type)};
  border: 1px solid ${(props) => getBorderColor(props.type)};
  border-radius: 8px;
  padding: 16px;

  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

const Alert = ({
  title,
  body,
  type,
}: {
  title?: string | JSX.Element;
  body?: string | JSX.Element;
  type: AlertType;
}) => {
  const Title = useMemo(() => {
    if (!title) return null;

    if (typeof title === 'string') {
      return <Typography.Body type="Label">{title}</Typography.Body>;
    }

    return <>{title}</>;
  }, [title]);

  const Body = useMemo(() => {
    if (typeof body === 'string') {
      return <Typography.Body type="Body 12">{body}</Typography.Body>;
    }

    return <>{body}</>;
  }, [body]);

  return (
    <AlertDiv type={type}>
      {Title}
      {Body}
    </AlertDiv>
  );
};

export default Alert;
